import styled from 'styled-components';
import { layout, media } from 'src/components/base';
import { DropdownToggle as DropdownToggleComponent } from '@prisjakt/ui/dropdown';
import { ButtonText } from '@prisjakt/ui/button';

export const VariantGridHeader = styled.div`
  display: grid;
  margin-bottom: 0.5rem;
`;

export const VariantGridWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: ${layout.measurements.spacing050};

  & + & {
    margin-top: 0.5rem;
    padding-top: 0.5rem;
    border-top: 1px solid ${p => p.theme.lines.primary};
  }

  ${media.mediumUp`
    margin: 0 ${layout.measurements.spacing050};
    grid-template-columns: repeat(5, max-content);
  `}
`;

export const VariantGridCell = styled.div`
  min-width: 62px;
  padding: 1px;
`;

export const VariantGridTitle = styled.div`
  grid-column: span 4;
  margin-bottom: ${layout.measurements.spacing050};
`;

export const DropdownToggle = styled(DropdownToggleComponent)`
  width: auto;
  min-width: 206px;
`;

export const DropdownButtonText = styled(ButtonText)`
  text-align: left;
`;

export const SelectionButtonText = styled(ButtonText)`
  max-width: 100px;
`;

export const SelectionHighlightedText = styled.span`
  color: ${p => p.theme.colors.maybeBlue700};
`;

export const ScrollableArea = styled.div`
  ${media.mediumUp`
    max-height: 340px;
    overflow-y: auto;
    overflow-x: hidden;
    padding-top: 1px;
  `}
`;
